import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Title, Text, Stack, Loader } from '@mantine/core';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '@/firebaseConfig';

export const AuthComplete = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'error'>('loading');

  useEffect(() => {
    const token = searchParams.get('token');
    const tenantId = searchParams.get('tenantId');

    if (!token || !tenantId) {
      setStatus('error');
      return;
    }

    let cancelled = false;

    const run = async () => {
      try {
        (auth as unknown as { tenantId: string }).tenantId = tenantId;
        await signInWithCustomToken(auth, token);
        if (cancelled) return;
        window.history.replaceState({}, '', '/matters');
        navigate('/matters', { replace: true });
      } catch (err) {
        if (cancelled) return;
        console.error('Auth complete sign-in failed', err);
        setStatus('error');
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (status === 'error') {
    return (
      <Container size='sm' py='xl'>
        <Stack gap='lg'>
          <Title order={1}>Sign-in link invalid or expired</Title>
          <Text c='dimmed'>
            Please sign in with your email and password, or use the link from
            your signup email.
          </Text>
          <Text
            component='a'
            href='/login'
            c='var(--mantine-color-blue-6)'
            style={{ cursor: 'pointer' }}
          >
            Go to sign in
          </Text>
        </Stack>
      </Container>
    );
  }

  return (
    <Container size='sm' py='xl'>
      <Stack gap='lg' align='center'>
        <Loader type='dots' color='pink.4' size='lg' />
        <Title order={1}>Signing you in</Title>
      </Stack>
    </Container>
  );
};
